import { styled } from '@mui/material/styles'
import Box, { BoxProps } from '@mui/material/Box'

interface HeaderMenuProps extends BoxProps {
  mobile: boolean
  tablet: boolean
}

export const Container = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  flexGrow: 1,
  [theme.breakpoints.down('tablet')]: {
    width: 258
  },
  [theme.breakpoints.up('tablet')]: {
    width: 313
  },
  [theme.breakpoints.up('notebook')]: {
    width: 338
  }
}))

export const HeaderMenu = styled(Box)<HeaderMenuProps>(
  ({ theme, mobile, tablet }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: mobile || tablet ? 16 : 40,
    backgroundColor: theme.palette.background.primary,
    height: 56,

    button: {
      color: theme.palette.text.primary,
      marginLeft: 16,
      '&:hover': {
        backgroundColor: theme.palette.button?.hover
      }
    }
  })
)

export const UnidadeOrganizacionalBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,

  hr: {
    borderWidth: 1,
    height: 20,
    borderColor: theme.palette.border?.terciary,
    borderRadius: 1
  },

  h1: {
    fontSize: 14,
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: theme.palette.text.primary
  }
}))
